import { useMaterialUIController } from "context";
import { setLayout } from "context";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  const [, dispatch] = useMaterialUIController();

  useEffect(() => {
    setLayout(dispatch, "page");
  }, [])

  return (
    <div id='oopss'>
      <div id='error-text'>
        <img src="https://cdn.rawgit.com/ahmedhosna95/upload/1731955f/sad404.svg" alt="404" />
          <span>404 PAGE</span>
          <p class="p-a">
            . The page you were looking for could not be found</p>
          <Link to="/" className="back">
            Go Home
          </Link>
      </div>
    </div>
  );
};

export default NotFound;
